// Search terms on the Grammar page that actually point to content living on
// a *different* page entirely - e.g. the Te-form is taught on the Verb
// Conjugation page (src/components/ConjugationPage), not as a grammarPoints
// entry. Without this, searching for them returns nothing useful (or only
// incidental substring matches), so GrammarPage surfaces a pointer instead.
//
// Extend this list as more of these cross-page gaps turn up (nai form, ta
// form, masu form, etc.) - no restructuring needed, just another entry.
export type CrossPageSuggestion = {
    // Search terms that should surface this suggestion, compared against the
    // query after both sides go through GrammarPage's normalizeSearchText -
    // so matching stays consistent (case, diacritics, punctuation) with the
    // page's real search.
    matches: string[];
    // Key under the grammarPage i18n namespace's "crossPageSuggestions"
    // object; resolved to `${labelKey}.text` and `${labelKey}.linkText`.
    labelKey: string;
    // Unlocalized app path the suggestion links to.
    to: string;
};

export const CROSS_PAGE_SUGGESTIONS: CrossPageSuggestion[] = [
    { matches: ["te", "te form", "teform"], labelKey: "teForm", to: "/conjugation" },
    // Adjective forms (negative, past, ...) have a page of their own; the grammar
    // entries only cover adjective + です. Portuguese terms are matched too.
    {
        matches: ["adjective", "adjectives", "i adjective", "na adjective", "adjetivo", "adjetivos"],
        labelKey: "adjectiveForms",
        to: "/adjective-conjugation",
    },
];
